var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScoreDuringPeriod = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.986 14C20.258 14 14 20.272 14 28C14 35.728 20.258 42 27.986 42C35.728 42 42 35.728 42 28C42 20.272 35.728 14 27.986 14ZM28 39.2C21.812 39.2 16.8 34.188 16.8 28C16.8 21.812 21.812 16.8 28 16.8C34.188 16.8 39.2 21.812 39.2 28C39.2 34.188 34.188 39.2 28 39.2ZM28.7 21H26.6V29.4L33.95 33.81L35 32.088L28.7 28.35V21Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScoreDuringPeriod);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/score_during_period.1905b94f67cb7f9a00b682f800c842a6.svg";